module.exports = __webpack_public_path__ + "img/dashboard.3b77034c.gif";